import { render, staticRenderFns } from "./UpvoteButton.vue?vue&type=template&id=87f628c0&scoped=true&"
import script from "./UpvoteButton.vue?vue&type=script&lang=js&"
export * from "./UpvoteButton.vue?vue&type=script&lang=js&"
import style0 from "./UpvoteButton.vue?vue&type=style&index=0&id=87f628c0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87f628c0",
  null
  
)

export default component.exports